import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 86B5194A-AB94-4C20-8110-FA463B705B39
 * name ideogram-cjk
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ideogram-cjk.svg
 * tags
 * - Alpha / Numeric 
 */
export const IdeogramCjkIcon = createSvgIcon(<><path d="M11 4V6H4V10H6V8H18V10H20V6H13V4M8 10V12H13.59L11.59 14H4V16H11V18H10V20H13V16H20V14H14.21L16 12.21V10Z" /></>, 'IdeogramCjkIcon');
export default IdeogramCjkIcon